import { Link } from "react-router-dom";

interface BreadcrumbProps {
  pageName: string;
  header?: string;
}

const Breadcrumb = ({ pageName, header }: BreadcrumbProps) => {
  return (
    <div className="mb-4 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-title-md font-semibold text-black dark:text-white">
        {header ?? pageName}
      </h2>
      <nav>
        <ol className="flex items-center gap-1">
          <li>
            <Link className="text-sm font-medium" to="/">
              Начало /
            </Link>
          </li>
          <li className="text-primary text-sm font-medium">{pageName}</li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
